import { Button, DataHeader, DataSource, Layout, Panel, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutUser extends Layout {
    buttonCopyUser: Button;
    buttonSetWebPassword: Button;
    buttonUserGroups: Button;
    dataheaderUser: DataHeader;
    layoutUserGeneral: Layout;
    layoutUserLogin: Layout;
    panelAdminButtons: Panel;
    sourceUserSettings: DataSource;
    tabGeneral: Tab;
    tabLogin: Tab;
    tabsetUsers: Tabset;
}
